import {
    IonButton,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonRow,
} from "@ionic/react";
import { addCircleOutline, addOutline } from "ionicons/icons";
import { AssignFormSearchBar } from "./AssignFormSearchBar";
import { selectFormListAvailable } from "../../../store/profileFormAssigned/selector/selectFormListAvailable";
import { useDispatch, useSelector } from "react-redux";
import { setPreselectedAll, setPreselectedForm } from "../../../store/profileFormAssigned";

export const AssignFormSelector = () => {
    const dispatch = useDispatch();
    const formList = useSelector(selectFormListAvailable);

    const handlePreselectedFormClick = async (form: { id: string, name: string }) => {
        dispatch(setPreselectedForm(form));
    }

    const handlePreselectedAllFormClick = async () => {
        dispatch(setPreselectedAll(formList));
    }

    return (
        <IonContent>
            <AssignFormSearchBar />
            <IonRow style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 10px 15px 15px"
            }}
            >
                <div>{formList.length} plantillas disponibles</div>
                <div>
                    {!!formList.length && (
                        <IonButton fill="solid" size="small" color="primary" onClick={handlePreselectedAllFormClick}>
                            <small>Agregar todos</small>
                            <IonIcon icon={addCircleOutline} slot="end" />
                        </IonButton>
                    )}
                </div>
            </IonRow>
            <IonList>
                {formList.map((form) => (
                    <IonItem key={form.id}>
                        <IonLabel>{form.name}</IonLabel>
                        <IonButton onClick={() => handlePreselectedFormClick(form)}>
                            <IonIcon icon={addOutline} />
                        </IonButton>
                    </IonItem>
                ))}
            </IonList>
        </IonContent>
    );
};